import styled from "styled-components";
import { Locale } from "@dealer-center/ddc-core-utils";
import type { MultiSelectEntry } from "./MultiSelect";
import { MultiSelect } from "./MultiSelect";
const Panel = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 16px;
`;

const StyledFilterByLabel = styled.div`
  color: #6d6d6d;
  display: flex;
  flex-shrink: 0;
  :after {
    content: ":";
  }
`;

interface PrefFilterPanelProps {
  filters: {
    franchises: MultiSelectEntry[];
    states: MultiSelectEntry[];
  };
  setFilters: (filters: {
    franchises: MultiSelectEntry[];
    states: MultiSelectEntry[];
  }) => void;
}

export const PrefFilterPanel = ({
  filters,
  setFilters
}: PrefFilterPanelProps) => {
  const { franchises, states } = filters;
  return (
    <Panel>
      <StyledFilterByLabel>{Locale.getText("FILTER_BY")}</StyledFilterByLabel>
      <MultiSelect
        label={Locale.getText("FRANCHISE") as string}
        list={franchises}
        realtimeChanges={true}
        onChange={list => setFilters({ ...filters, franchises: list })}
      />
      <MultiSelect
        label={Locale.getText("STATE") as string}
        list={states}
        realtimeChanges={true}
        onChange={list => setFilters({ ...filters, states: list })}
      />
    </Panel>
  );
};
